(() => {
  const buttons = qsa('.js-collection-view');
  const container = qs('#js-collection-products-wrap');
  const collectionView = sessionStorage.getItem('collection_view');
  const buttonActive = 'collection-products__view-link--active';
  const viewMore = qs('.js-collection-products__links .collection-products__link-button button');
  const collectionItems = qsa('.js-collection-products__item');
  const scrollUp = qsa('.js-collection-products__links a[href^="#"]');
  const anchor = qs('.js-collection-products__links a');

  if(collectionView) {
    sessionStorage.setItem('collection_view', collectionView);
    container.dataset.collectionView = collectionView;
  }

  if(buttons) {
    buttons.forEach(item => {
      const buttonView = item.dataset.buttonCollectionView;
      if(container.dataset.collectionView === buttonView) {
        item.classList.add(buttonActive);
      }
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const el = e.currentTarget;
        const layout = el.dataset.buttonCollectionView;
        buttons.forEach(btn => {
          btn.classList.remove(buttonActive);
        })
        el.classList.add(buttonActive);
        container.dataset.collectionView = layout;
        sessionStorage.setItem('collection_view', layout);
      })
    })
  }

  scrollUp.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
				
        document.querySelector(this.getAttribute('href')).scrollIntoView({
					behavior: 'smooth'
        });
    });
  });

  if (viewMore) {
    viewMore.addEventListener('click', function (e) {
      e.preventDefault();
      
      e.target.style.display = 'none';
      anchor.style.marginTop = '0';
  
      // collectionItems.forEach(collectionItem => collectionItem.classList.remove('collection-products__item--hidden'));
      collectionItems.forEach(collectionItem => collectionItem.style.display = 'block');
    })
  }
})();
